import apiRequest from "./apiClient";
import { fetchWithCache } from "../utils/adminCache";
import { DEFAULT_DASHBOARD_OVERVIEW } from "../utils/adminStatsDefaults";

export async function fetchDashboardOverview(options = {}) {
  return fetchWithCache(
    "admin:dashboard:overview",
    async () => {
      const body = await apiRequest("/api/v1/admin/dashboard/overview");
      return body.data;
    },
    { fallback: DEFAULT_DASHBOARD_OVERVIEW, ...options }
  );
}
